import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { LogOut, Shield, FileText } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { api, loginUrl, useMe } from "@/lib/api";

export const DiscordIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.3 4.4A19.7 19.7 0 0 0 15.4 3l-.6 1.3a18.3 18.3 0 0 0-5.6 0L8.6 3a19.6 19.6 0 0 0-4.9 1.5C.6 9.1-.3 13.7.1 18.2a19.9 19.9 0 0 0 6 3l1.3-2.1c-.7-.3-1.4-.6-2-1l.5-.4a14.1 14.1 0 0 0 12.2 0l.5.4c-.6.4-1.3.7-2 1l1.3 2.1a19.8 19.8 0 0 0 6-3c.5-5.2-.9-9.8-3.6-13.8ZM8 15.4c-1.2 0-2.2-1.1-2.2-2.4s1-2.4 2.2-2.4 2.2 1.1 2.2 2.4-1 2.4-2.2 2.4Zm8 0c-1.2 0-2.2-1.1-2.2-2.4s1-2.4 2.2-2.4 2.2 1.1 2.2 2.4-1 2.4-2.2 2.4Z" />
  </svg>
);

export const LoginButton = ({ next, className = "btn-ice", label = "دخول بالديسكورد", testid = "discord-login-btn" }) => (
  <a href={loginUrl(next)} className={`${className} !bg-[#5865F2] !text-white !shadow-[0_10px_30px_rgba(88,101,242,0.35)]`} data-testid={testid}>
    <DiscordIcon /> {label}
  </a>
);

export default function UserMenu() {
  const { data: me, isLoading } = useMe();
  const qc = useQueryClient();
  if (isLoading) return <div className="h-9 w-9 animate-pulse rounded-full bg-slate-800" />;
  if (!me) return <LoginButton className="btn-ghost !py-2 !px-3" label="دخول" testid="nav-login-btn" />;
  const logout = async () => { await api.post("/auth/logout"); qc.setQueryData(["me"], null); };
  return (
    <DropdownMenu dir="rtl">
      <DropdownMenuTrigger className="flex items-center gap-2 rounded-full border border-sky-400/20 py-1 pe-3 ps-1 transition-colors hover:border-sky-400/60" data-testid="user-menu-trigger">
        {me.avatar ? <img src={me.avatar} alt="" className="h-8 w-8 rounded-full" /> : <div className="grid h-8 w-8 place-items-center rounded-full bg-[#5865F2]"><DiscordIcon /></div>}
        <span className="hidden max-w-[110px] truncate text-sm sm:block" data-testid="user-menu-name">{me.global_name || me.username}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52 border-sky-400/20 bg-[#0b1220] text-slate-100">
        <DropdownMenuItem asChild><Link to="/apply#mine" data-testid="user-menu-my-apps"><FileText size={15} className="me-2" />تقديماتي</Link></DropdownMenuItem>
        {me.is_admin && <DropdownMenuItem asChild><Link to="/admin" data-testid="user-menu-admin"><Shield size={15} className="me-2" />لوحة التحكم</Link></DropdownMenuItem>}
        <DropdownMenuSeparator className="bg-sky-400/10" />
        <DropdownMenuItem onClick={logout} className="text-rose-300" data-testid="user-menu-logout"><LogOut size={15} className="me-2" />تسجيل خروج</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
